import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import Exporting from 'highcharts/modules/exporting';
import Accessibility from 'highcharts/modules/accessibility';
import HighchartsReact from 'highcharts-react-official';
import ToggleButton from '@mui/material/ToggleButton';
import Typography from '@mui/material/Typography';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Button from '@mui/material/Button';
import About from './About';
import { default_options } from './chartOptions';
import { fill_graph_crntyr } from './fill_graph_crntyr';
import { fill_graph_pcts } from './fill_graph_pcts';
import { buildDateList } from './buildDateList';

HighchartsMore(Highcharts);
Exporting(Highcharts);
Accessibility(Highcharts);

const GwGraph = (props) => { 
  const defaultStnid = 433112075091501;
  const currentDataFile = (props.match ? '..' : '.') + '/data/nwis_current.json';
  const dataFileNameBase = (props.match ? '..' : '.') + '/data/percentiles/gw_percentiles_';
  const [ searchParams, setSearchParams ] = useSearchParams();
  const [ showDialog, setShowDialog ] = useState(false);
  const [ stnid, setStnid ] = useState(defaultStnid);
  const [ areaSelection, setAreaSelection ] = useState('default');
  const [ chart, setChart ] = useState(null);
  const [ datelist, setDatelist ] = useState([]);
  const [ options, setOptions ] = useState(default_options);

  // access to chart
  const afterChartCreated = (chart) => {
    setChart(chart);
    chart.showLoading();
  };

  const handleOpenDialog = () => { setShowDialog(true); };
  const handleCloseDialog = () => { setShowDialog(false); };

  const handleCatTypeChange = (e) => {
    const newcats = e.target.value;
    // update parameters in url
    setSearchParams({id:stnid, cats:newcats});
    // remove all series accept those for current year
    for (let i = chart.series.length-1; i >= 0; i--) {
      if (!['approved','provisional'].some(term => chart.series[i].name.includes(term))) {
        chart.series[i].remove();
      }
    }
    // add new percentile fills
    fill_graph_pcts(dataFileNameBase, stnid, newcats, datelist, chart);
  };

  useEffect(() => {
    if (!datelist.length) {
      setDatelist(buildDateList());
    } else {
      fill_graph_pcts(dataFileNameBase, stnid, areaSelection, datelist, chart);
      fill_graph_crntyr(currentDataFile, stnid, datelist, chart);
      chart.hideLoading();
    }
    // eslint-disable-next-line
  }, [datelist]);

  // get station id and cat type (default or usdm) from url
  useEffect(() => {
    if (searchParams.has('id')) {
      setStnid(searchParams.get('id'));
    }
    if (searchParams.has('cats')) {
      setAreaSelection(searchParams.get('cats'));
    }
      // eslint-disable-next-line
  }, [searchParams]);

  return (
    <>
      <HighchartsReact
          highcharts={Highcharts}
          options={options}
          callback={afterChartCreated}
      />

      <div style={{paddingLeft:'1em'}}>
        <Typography variant="subtitle2">Percentile categories: </Typography>
        <ToggleButtonGroup 
          value={areaSelection}
          exclusive
          size="small"
          color="primary"
          onChange={handleCatTypeChange}
        >
          <ToggleButton value="default">Default</ToggleButton>
          <ToggleButton value="usdm">USDM</ToggleButton>
        </ToggleButtonGroup>

        <Button 
          variant="outlined"
          size="small"
          sx={{position:'absolute',right:"1em"}}
          onClick={handleOpenDialog}
        >
          About this product
        </Button>
      </div>
      
      <About 
        showDialog={showDialog}
        handleClose={handleCloseDialog}
      />
    </>
  )
}

export default GwGraph;
